import React from 'react';
import { DatePicker } from 'rsuite';
import { Button, Modal } from '@nsi-advisory-services/components';

// Marking an expense paid always asks the same question — what date the money
// went out — and it is asked from the payroll board, the payroll tables and the
// approval details dialog. The dialog lives here so all three ask it the same
// way rather than each keeping its own copy.
//
// The date is held by the caller, alongside whichever expense the dialog was
// opened on: the two are one piece of state, and the caller is what submits it.
export default function ExpenseMarkPaidModal({
  open,
  value,
  onChange,
  onSubmit,
  onClose,
  loading,
}) {
  return (
    // Often opened on top of the approval details dialog; the shared Modal
    // stacks it above that one and shades it.
    <Modal open={open} onClose={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>Mark Expense Paid</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-muted small mb-1">Paid On Date</div>
        <DatePicker
          value={value}
          onChange={onChange}
          oneTap
          cleanable={false}
          isoWeek={false}
          weekStart={0}
          format="MM/dd/yyyy"
          style={{ width: '100%' }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} disabled={!!loading}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={!value}
          loading={!!loading}
        >
          Mark Paid
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
